import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    fontSize: "30px",
    color: (props) =>
      props.color == "secondary"
        ? theme.palette.secondary.main + " !important"
        : theme.palette.primary.dark + " !important", // Stupid with important, but desktop has overrides :/
    fontWeight: 500,
    lineHeight: "1.1em",
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(0),
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      marginBottom: theme.spacing(2),
    },
  },
}));

const Level2BoxHeading = ({ children, ...props }) => {
  const classes = useStyles(props);

  return <h2 className={classes.root}>{children}</h2>;
};

Level2BoxHeading.defaultProps = {
  color: "secondary",
};

export default Level2BoxHeading;
